// ─── formatPrice.js ─────────────────────────────────────────────────────────
// Every Material and Furniture price on screen goes through these two
// functions, so "SGD" and the decimals look the same everywhere.

// Material prices are free text without the currency, e.g. "4.60 / sqft".
// (The server removes any "SGD", "S$" or "$" people type.)
//   formatMaterialPrice('4.60 / sqft') → 'SGD 4.60 / sqft'
//   formatMaterialPrice(null)          → '—'
export function formatMaterialPrice(text) {
  const t = (text ?? '').toString().trim();
  return t ? `SGD ${t}` : '—';
}

// Furniture prices are numbers (or number-like text from the Moodboard
// pop-up). Always 2 decimal places.
//   formatFurniturePrice(1299.5)    → 'SGD 1299.50'
//   formatFurniturePrice('1300')    → 'SGD 1300.00'
//   formatFurniturePrice(null)      → '—'
export function formatFurniturePrice(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  return Number.isFinite(n) ? `SGD ${n.toFixed(2)}` : '—';
}
